'use client';

import { useTranslations } from 'next-intl';
import { useContext, useState } from 'react';

import { DropzoneManager } from '@hrworks/sui-core/Dropzone';
import { FileManager, type FileManagerValue } from '@hrworks/sui-core/FileManager';
import { FontAwesomeIcon } from '@hrworks/sui-core/FontAwesomeIcon';
import { Grid } from '@hrworks/sui-core/Grid';
import { GridItem } from '@hrworks/sui-core/GridItem';

import { ApplicationFormContext } from '../ApplicationFormContext';
import { S } from './ApplicationFormFileManager.styles';
import type { ApplicationFormFileManagerProps } from './ApplicationFormFileManager.types';

export const ApplicationFormFileManager = ({ onFileCountChange }: ApplicationFormFileManagerProps) => {
  const t = useTranslations('FormFields.files');
  const { formState } = useContext(ApplicationFormContext);
  const [value, setValue] = useState<FileManagerValue[]>([]);

  const onValueChange = (newValue: FileManagerValue[]) => {
    setValue(newValue);
    onFileCountChange?.(newValue.length);
  };

  const fileError = formState.errors?.files?.[0];

  return (
    <DropzoneManager>
      <GridItem>
        <Grid gap="40px">
          <GridItem>
            <S.FileManagerWrapper data-guide-id="form-file-upload">
              <FileManager
                value={value}
                name="files"
                mode="growing"
                helpText={t('helptext')}
                validationMessage={fileError}
                validationState="danger"
                validations={{
                  allowedFileTypes: {
                    value: ['application/pdf', 'image/jpeg', 'image/png'],
                    errorMessage: t('errors.allowedFileTypes'),
                    extensions: ['.pdf', '.jpg', '.jpeg', '.png'],
                  },
                  sizeOfAllFiles: {
                    value: 20 * 1024 * 1024,
                    errorMessage: t('errors.sizeOfAllFiles'),
                  },
                  maxFileAmount: {
                    value: 5,
                    errorMessage: t('errors.maxFileAmount'),
                  },
                }}
                onValueChange={onValueChange}
                trigger={
                  <S.Button variant="subtle">
                    {t('label')}
                    <FontAwesomeIcon name="plus" />
                  </S.Button>
                }
              />
            </S.FileManagerWrapper>
          </GridItem>
        </Grid>
      </GridItem>
    </DropzoneManager>
  );
};
